import React from 'react';

import { T } from '../../../../common/locale/translate';
import { offerTypes } from '../objects/offer_types';
import {
  checkAvailability,
  destinationAirport,
  formatInterchangeDate,
  formatInterchangeTime,
  link2OfferFlight,
  link2OfferWithHotel,
  returnAirport,
  unixTime2Date,
  unixTime2Hour
} from '../../services/services';

import Cell from './responsive-table-cell';
import InterchangesAlert from './interchanges_alert';
import Loader from './loader';
import Operator from './operator';
import Price from './price';
import Row from './responsive-table-row';

export default class OfferListElement extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      action_states: { pristine: true, in_progress: false, available: false },
      current_state: 'pristine',
      action_text: T('check'),
      title_text: 'check_offer',
      offer_link: 'javascript:void(0)',
      loading_text: T('checking'),
      promotionTreshold: 5, // in %
      loader: false,
      params: props.params,
      data: props.data,
      is_price_estimated: true,
      is_interchanges_alert_visible: this.shouldRenderInterchangesAlert(
        props.data,
        props.data.offer_type
      )
    };
  }

  componentDidMount = () => {
    if (this.props.checkAvailability) {
      this.checkOfferAvailability();
    }
    // TODO set this.state.offer_link to value returned from createOfferLink
  };

  componentWillReceiveProps = nextProps => {
    if (this.props.reloadOnPropsData) {
      this.setState({ data: nextProps.data });
    }
  };

  render = () => {
    const action = this.state.action_states;
    const available =
      action.pristine + action.in_progress + action.available === 1;
    const shouldRender = this.props.shouldRenderWhenUnavailable || available;
    return shouldRender ? (
      <Row
        className={available ? 'available' : 'unavailable'}
        headers={this.props.headers}
      >
        {this.props.headers.map((header, i) =>
          this.ComponentElements(header.name, i)
        )}
      </Row>
    ) : null;
  };

  handleClick = () => {
    if (this.state.current_state === 'pristine') {
      this.checkOfferAvailability();
    }
  };

  availabilityParams = () => {
    return {
      parser: this.state.data.subject.parser,
      operator_code: this.state.data.operator.code,
      hotel_id: this.state.data.subject.id,
      adults_number: this.state.params.adults_number,
      children_ages: this.state.data.children_ages.join(','),
      offer_type: this.state.data.offer_type,
      offer_id: this.state.data.id,
      departure_date: this.state.data.departure_date,
      return_date: this.state.data.return_date
    };
  };

  offerLinkParams = () => {
    return {
      id: this.state.data.subject.id,
      operator_code: this.state.data.operator.code,
      parser: this.state.data.subject.parser,
      offer_type: this.state.data.offer_type,
      offer_id: this.state.data.id,
      adults_number: this.state.data.adults_number,
      children_ages: this.state.data.children_ages.join(','),
      departure_airports: this.state.params.departure_airports
        ? this.state.params.departure_airports
        : '',
      boards: this.state.params.boards ? this.state.params.boards : '',
      departure_date: this.state.params.departure_date,
      return_date: this.state.params.return_date,
      accommodations: this.state.params.accommodations
        ? this.state.params.accommodations
        : '',
      duration_min: this.state.params.duration_min,
      duration_max: this.state.params.duration_max
    };
  };

  checkOfferAvailability = () => {
    if (typeof this.props.updatePendingRequestCounter === 'function') {
      const uuid = this.state.data.uuid;
      this.props.updatePendingRequestCounter(uuid, 'ADD');
    }

    const action = this.state.action_states;
    if (action.pristine) {
      action.pristine = false;
      action.in_progress = true;
      this.setState({
        action_states: action,
        current_state: 'in_progress',
        loader: true
      });
      checkAvailability(this.availabilityParams())
        .then(
          response => {
            const availabilityCode = response.data.availability.code;
            if (availabilityCode !== 'NA' && availabilityCode !== 'XX') {
              action.in_progress = false;
              action.available = true;
              const link =
                this.state.data.offer_type.indexOf('C') > -1
                  ? link2OfferFlight(this.offerLinkParams())
                  : link2OfferWithHotel(this.offerLinkParams());
              const data =
                this.mergeAvailabilityData(response) || this.state.data;
              const is_interchanges_alert_visible = this.shouldRenderInterchangesAlert(
                response.data,
                this.props.data.offer_type
              );

              //for setting the lowest price indicators
              if (typeof this.props.updateTheLowestPrice === 'function') {
                this.props.updateTheLowestPrice(data.price_pln);
              }

              //for setting proper sorting of offers_list
              if (typeof this.props.updateOfferPrice === 'function') {
                this.props.updateOfferPrice(data);
              }

              this.setState({
                action_states: action,
                current_state: 'available',
                loader: false,
                offer_link: link,
                action_text: T('choose'),
                title_text: 'go_to_offer',
                is_price_estimated: false,
                data,
                is_interchanges_alert_visible
              });
            } else {
              action.in_progress = false;
              action.available = false;
              this.setState({
                action_states: action,
                current_state: 'unavailable',
                loading_text: T('offer_unavailable'),
                loader: false
              });
            }
          },
          () => {
            action.in_progress = false;
            action.available = false;
            this.setState({
              action_states: action,
              current_state: 'unavailable',
              loading_text: T('offer_unavailable'),
              loader: false
            });
          }
        )
        .then(() => {
          if (typeof this.props.updatePendingRequestCounter === 'function') {
            const uuid = this.state.data.uuid;
            this.props.updatePendingRequestCounter(uuid, 'REMOVE');
          }
        });
    }
  };

  promotionalPrices = () => {
    const generalOfferPrice = this.props.price;
    const currentOfferPrice = this.state.data.price_pln;
    const lowestPrice = this.props.lowestPrice;
    const discount =
      100 - (parseInt(currentOfferPrice) / parseInt(generalOfferPrice)) * 100;

    return {
      isPromotionPrice: discount >= this.state.promotionTreshold,
      isLowestPrice: Math.floor(lowestPrice) === Math.floor(currentOfferPrice),
      discount: parseInt(discount)
    };
  };

  mergeAvailabilityData = response => {
    const {
      price_eur,
      price_pln,
      price_total_eur,
      price_total_pln,
      flights
    } = response.data;

    let response_data = {
      price_eur,
      price_pln,
      price_total_eur,
      price_total_pln
    };

    const responseFlights = typeof flights !== 'undefined' ? flights : [];
    // update flights only if previously where empty
    if (
      responseFlights.length > 0 &&
      !(this.state.data.flights && this.state.data.flights.length > 0)
    ) {
      response_data.flights = responseFlights;
    }

    if (price_eur && price_pln && price_total_eur && price_total_pln) {
      return {
        ...this.state.data,
        ...response_data
      };
    }
  };

  ComponentElements = (key, index) => {
    const data = this.state.data;
    const destination_airport = destinationAirport(data);
    const return_airport = returnAirport(data);

    const elements = {
      flight: data => (
        <Cell className="flight" key={`flight-${index}`}>
          {this.state.is_interchanges_alert_visible && <InterchangesAlert />}
          <div>{data.flights[0].departure_airport_name}</div>
        </Cell>
      ),
      departure: data => (
        <Cell className="departure" key={`departure-${index}`}>
          <div> {unixTime2Date(data.departure_date)} </div>
        </Cell>
      ),
      arrival: data => (
        <Cell className="arrival" key={`arrival-${index}`}>
          <div> {unixTime2Date(data.return_date)} </div>
        </Cell>
      ),
      duration: data => (
        <Cell className="duration" key={`duration-${index}`}>
          <div> {`${data.trip_duration} dni`} </div>
        </Cell>
      ),
      provider: data => (
        <Cell className="provider" key={`provider-${index}`}>
          <div>
            {' '}
            <Operator operator={data.operator} />{' '}
          </div>
        </Cell>
      ),
      alimentation: data => (
        <Cell className="alimentation" key={`alimentation-${index}`}>
          <div>
            {data.boards.map((alimentation, i) => (
              <span key={`alimentation-element-${i}`}>{alimentation.name}</span>
            ))}
          </div>
        </Cell>
      ),
      accommodation: data => (
        <Cell className="accommodation" key={`accommodation-${index}`}>
          <div>
            {data.accommodation.polish_name
              ? data.accommodation.polish_name
              : data.accommodation.name}
          </div>
        </Cell>
      ),
      route: data => (
        <Cell className="route" key={`route-${index}`}>
          {this.state.is_interchanges_alert_visible && <InterchangesAlert />}
          <div>
            <div>
              <span className="departure">
                <span className="name">
                  <i className="icon fa fa-plane" />
                  <span className="title">{T('departure')}</span>
                </span>
                <span className="airport">
                  {`${
                    data.flights[0].departure_airport_iata
                      ? data.flights[0].departure_airport_iata
                      : ''
                  } - ${
                    data.flights[0].departure_airport_name
                      ? data.flights[0].departure_airport_name
                      : ''
                  }`}
                </span>
              </span>
            </div>
            <div>
              <span className="arrival">
                <span className="name">
                  <i className="icon fa fa-plane" />
                  <span className="title">{T('arrival')}</span>
                </span>
                <span className="airport">
                  {destination_airport &&
                  typeof destination_airport != 'undefined'
                    ? `${
                        destination_airport &&
                        destination_airport.arrival_airport_iata
                          ? destination_airport.arrival_airport_iata
                          : ''
                      } - ${
                        destination_airport.arrival_airport_name
                          ? destination_airport.arrival_airport_name
                          : ''
                      }`
                    : `${
                        data.flights[0].arrival_airport_iata
                          ? data.flights[0].arrival_airport_iata
                          : ''
                      } - ${
                        data.flights[0].arrival_airport_name
                          ? data.flights[0].arrival_airport_name
                          : ''
                      }`}
                </span>
              </span>
            </div>
          </div>
        </Cell>
      ),
      departure_details: data => (
        <Cell className="departure-details" key={`departure-details-${index}`}>
          <div>
            <div className="date-wrapper">
              <i className="icon fa fa-calendar" />
              <span className="date">
                {data.flights[0].departure
                  ? unixTime2Date(data.flights[0].departure)
                  : ' - '}
              </span>
            </div>
            <div>
              <i className="icon fa fa-clock-o" />
              <span className="time">
                {`${
                  data.flights[0].departure
                    ? unixTime2Hour(data.flights[0].departure)
                    : ' - '
                } - ${
                  destination_airport && destination_airport.arrival
                    ? unixTime2Hour(destination_airport.arrival)
                    : ' - '
                }`}
              </span>
            </div>
          </div>
        </Cell>
      ),
      arrival_details: data => (
        <Cell className="arrival-details" key={`arrival-details-${index}`}>
          <div>
            <div className="date-wrapper">
              <i className="icon fa fa-calendar" />
              <span className="date">
                {data.flights &&
                data.flights.length > 0 &&
                data.flights[data.flights.length - 1].departure
                  ? unixTime2Date(
                      data.flights[data.flights.length - 1].departure
                    )
                  : ' - '}
              </span>
            </div>
            <div>
              <i className="icon fa fa-clock-o" />
              <span className="time">
                {`${
                  return_airport && return_airport.departure
                    ? unixTime2Hour(return_airport.departure)
                    : ' - '
                } - ${
                  data.flights &&
                  data.flights.length > 0 &&
                  data.flights[data.flights.length - 1].arrival
                    ? unixTime2Hour(
                        data.flights[data.flights.length - 1].arrival
                      )
                    : ' - '
                }`}
              </span>
            </div>
          </div>
        </Cell>
      ),
      price: data => {
        const {
          isPromotionPrice,
          discount,
          isLowestPrice
        } = this.promotionalPrices();
        const isAvailable = this.state.current_state === 'available';
        return (
          <Cell className="price" key={`price-${index}`}>
            <div>
              <div
                className={`price-wrapper ${this.state.current_state} ${
                  isAvailable && isPromotionPrice ? 'promotion' : ''
                }`}
              >
                <Price
                  data={data}
                  is_estimated={this.state.is_price_estimated}
                  only_per_person={true}
                  isPromotionPrice={isPromotionPrice}
                  discount={discount}
                  isLowestPrice={isLowestPrice}
                  isAvailable={isAvailable}
                />
                <div className="action-element">
                  <a
                    rel="nofollow"
                    href={this.state.offer_link}
                    title={T(this.state.title_text)}
                    className="choose-offer"
                    onClick={this.handleClick}
                  >
                    {' '}
                    {this.state.action_text}{' '}
                  </a>
                </div>
                <span className="loading">
                  {this.state.loading_text}{' '}
                  <Loader active={this.state.loader} />
                </span>
              </div>
            </div>
          </Cell>
        );
      },
      iterchange_departure: (
        data // Cell type using for interchanges o offer and reservation page
      ) => (
        <Cell
          className="iterchange-departure-date"
          key={`iterchange-departure-date-${index}`}
        >
          <div>
            <div className="date-wrapper">
              <i className="icon fa fa-calendar" />
              <span className="date">
                {formatInterchangeDate(data.flights[0].departure)}
              </span>
            </div>
            <div>
              <i className="icon fa fa-clock-o" />
              <span className="time">
                {formatInterchangeTime(data.flights[0].departure)}
              </span>
            </div>
          </div>
        </Cell>
      ),
      iterchange_arrival: (
        data // Cell type using for interchanges o offer and reservation page
      ) => (
        <Cell
          className="iterchange-arrival-date"
          key={`iterchange-arrival-date-${index}`}
        >
          <div>
            <div className="date-wrapper">
              <i className="icon fa fa-calendar" />
              <span className="date">
                {formatInterchangeDate(data.flights[0].arrival)}
              </span>
            </div>
            <div>
              <i className="icon fa fa-clock-o" />
              <span className="time">
                {formatInterchangeTime(data.flights[0].arrival)}
              </span>
            </div>
          </div>
        </Cell>
      ),
      flight_no: (
        data // Cell type using for interchanges o offer and reservation page
      ) => (
        <Cell
          className="interchange-flight-number"
          key={`interchange-flight-number-${index}`}
        >
          <div>
            <div>
              <i className="icon fa fa-plane" />
              <span className="time">
                {data.flights[0].flight_number
                  ? data.flights[0].flight_number
                  : ' - '}
              </span>
            </div>
          </div>
        </Cell>
      ),
      airline_name: (
        data // Cell type using for interchanges o offer and reservation page
      ) => (
        <Cell
          className="interchange-airline-name"
          key={`interchange-airline-name-${index}`}
        >
          <div>
            <div>
              <i className="icon fa fa-plane" />
              <span className="date">
                {data.flights[0].airline_name
                  ? data.flights[0].airline_name
                  : ' - '}
              </span>
            </div>
          </div>
        </Cell>
      ),
      'mobile-price': data => {
        const {
          isPromotionPrice,
          discount,
          isLowestPrice
        } = this.promotionalPrices();
        const isAvailable = this.state.current_state === 'available';
        return (
          <Cell className="mobile-price" key={`mobile-price-${index}`}>
            <div
              className={`${
                isAvailable && isPromotionPrice ? 'promotion' : ''
              }`}
            >
              {isAvailable &&
                isPromotionPrice &&
                !isLowestPrice && (
                  <span className="promotion-price">{`-${discount}%`}</span>
                )}
              {isAvailable &&
                isPromotionPrice &&
                isLowestPrice && (
                  <span className="promotion-price the-lowest">
                    {T('cheapest')}
                  </span>
                )}
              <div className="dates">
                <div className="dates-wrapper">
                  <i className="icon fa fa-calendar" />
                  <div className="from">
                    {' '}
                    {unixTime2Date(data.departure_date)}{' '}
                  </div>
                  <div className="to"> {unixTime2Date(data.return_date)} </div>
                </div>
              </div>
              <Price data={data} is_estimated={this.state.is_price_estimated} />
            </div>
          </Cell>
        );
      },
      'mobile-choose-button': () => (
        <Cell
          className={`mobile-choose-button ${this.state.current_state}`}
          key={`mobile-choose-button-${index}`}
        >
          <div>
            <div className="action-element">
              <a
                rel="nofollow"
                href={this.state.offer_link}
                title={T(this.state.title_text)}
                className="choose-offer"
                onClick={this.handleClick}
              >
                <span className="action-text">{this.state.action_text}</span>
                <span className="loading">
                  {this.state.loading_text}{' '}
                  <Loader active={this.state.loader} />
                </span>
              </a>
            </div>
          </div>
        </Cell>
      )
    };

    return elements[key] ? elements[key](data) : <span>{T('no_element')}</span>;
  };

  shouldRenderInterchangesAlert = (offer_data, offer_type) => {
    // if flights are not exists then do nothing
    if (
      typeof offer_data.flights === 'undefined' ||
      offer_data.flights.length == 0
    ) {
      return false;
    }
    // if offer type is hotel only then do nothing
    if (offer_type === offerTypes.hotel_only) {
      return false;
    }

    let is_one_way_flight_with_interchanges =
      offer_type === offerTypes.one_way_flight && offer_data.flights.length > 1;
    let is_other_type_with_interchanges = offer_data.flights.length > 2;

    return (
      is_one_way_flight_with_interchanges || is_other_type_with_interchanges
    );
  };
}



// WEBPACK FOOTER //
// ./app/javascript/common/components/offer-list-element.js